export interface WaitForElementOptions {
  /**
   * @default document.body
   */
  rootElement?: HTMLElement | Document;
  /**
   * @default 3000
   */
  timeout?: number;
}

const waitForElement = <T extends HTMLElement>(
  selector: string,
  options: WaitForElementOptions = {}
): Promise<T | null> => {
  const { rootElement = document.body, timeout = 3000 } = options;

  return new Promise((resolve) => {
    const targetElement = rootElement.querySelector<T>(selector);

    if (targetElement) return resolve(targetElement);

    const timeoutId = setTimeout(() => {
      observer.disconnect();
      resolve(null);
    }, timeout);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type !== 'childList') continue;

        const element = rootElement.querySelector<T>(selector);
        const addedNodes = [...mutation.addedNodes];

        if (element && addedNodes.includes(element)) {
          observer.disconnect();
          clearTimeout(timeoutId);
          return resolve(element);
        }
      }
    });

    observer.observe(rootElement, { childList: true, subtree: true });
  });
};

export default waitForElement;
